import { handleDispatchResult } from "@utils/helpers/handleDispatchResult";
import * as Api from "@modules/api";
import { store } from "../store";
import { LibraryProgressListContentInput } from "./types";
import {
  getStartedAsync,
  getCompletedAsync,
  getFavoriteAsync,
  getBookmarkedAsync,
  getHighlightedAsync,
  getBookmarkedDetailsAsync,
  getHighlightedDetailsAsync,
  actions,
  createPlaylistAsync,
  removeItemFromPlaylistAsync,
  getPaginatedPlaylistsAsync,
  moveToPlaylistAsync,
  removePlaylistAsync,
  updatePlaylistAsync,
  addItemToPlaylistAsync,
  reArrangePlaylistItemsAsync,
} from "./slices";

export const clearMyLibraryState = () => {
  store.dispatch(actions.clear());
};

export const getStarted = async (
  body: LibraryProgressListContentInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getStartedAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const getCompleted = async (
  body: LibraryProgressListContentInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getCompletedAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const getFavorite = async (
  body: LibraryProgressListContentInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getFavoriteAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const getBookmarked = async (
  body: LibraryProgressListContentInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getBookmarkedAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const getHighlighted = async (
  body: LibraryProgressListContentInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getHighlightedAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const getBookmarkedDetails = async (
  containerContentEntityId: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getBookmarkedDetailsAsync(containerContentEntityId)
  );

  return handleDispatchResult(res, onSuccess);
};

export const getHighlightedDetails = async (
  containerContentEntityId: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getHighlightedDetailsAsync(containerContentEntityId)
  );

  return handleDispatchResult(res, onSuccess);
};

export const clearBookmarkedDetails = async () => {
  store.dispatch(actions.clearBookmarkedDetails());
};

export const clearHighlightedDetails = async () => {
  store.dispatch(actions.clearHighlightedDetails());
};

export const getPaginatedPlayLists = async (
  body: LibraryProgressListContentInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getPaginatedPlaylistsAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const createPlaylist = async (
  input: Api.Server.CreatePlaylistInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(createPlaylistAsync(input));

  return handleDispatchResult(res, onSuccess);
};

export const updatePlaylist = async (
  input: Api.Server.EditPlaylistInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(updatePlaylistAsync(input));

  return handleDispatchResult(res, onSuccess);
};

export const removePlaylist = async (
  input: number | undefined,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(removePlaylistAsync(input));

  return handleDispatchResult(res, onSuccess);
};

export const addItemToPlaylist = async (
  input: Api.Server.AddToPlaylistInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(addItemToPlaylistAsync(input));

  return handleDispatchResult(res, onSuccess);
};

export const removeItemFromPlaylist = async (
  input: Api.Server.RemoveFromPlaylistInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(removeItemFromPlaylistAsync(input));

  return handleDispatchResult(res, onSuccess);
};

export const moveToPlaylist = async (
  input: Api.Server.MoveToPlaylistInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(moveToPlaylistAsync(input));

  return handleDispatchResult(res, onSuccess);
};

export const arrangedplaylistItems = async (
  input: Api.Server.ArrangePlaylistItemsInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(reArrangePlaylistItemsAsync(input));

  return handleDispatchResult(res, onSuccess);
};
